import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { AppSettings } from '../../common/app.settings';
import { ErrorHandler } from '../../common/errorHandler';
import { AuthenticationService } from '../../services/authentication.service';
import { QuestionService } from '../../services/question.service';
import { QuestionGroupService } from '../../services/question.group.service';
import { Question } from '../../models/question.model';
import { QuestionGroup } from '../../models/question.group.model';
import { ResultCode } from '../../enums/resultcode.enum';

@Component({
    selector: 'question-list',
    templateUrl: './question-list.component.html',
    styleUrls: ['./question-list.component.css'],
    providers: [QuestionService, QuestionGroupService, ErrorHandler]
})
export class QuestionListComponent implements OnInit {
    questions: Array<Question>;
    questionGroup: QuestionGroup;
    questionGroups: Array<QuestionGroup>;
    baseImageAddress: string;
    isDataAvailable = false;

    constructor(
        private router: Router,
        private errorHandler: ErrorHandler,
        private questionService: QuestionService,
        private questionGroupService: QuestionGroupService) {
        this.questions = new Array<Question>();
        this.questionGroups = new Array<QuestionGroup>();
    }

    ngOnInit() {
        this.questionGroup = null;
        this.baseImageAddress = AppSettings.apiEndPoint + '/images/';
        this.getAll();
    }
    export(): void {
        this.questionService.exportQuestions(this.questionGroup.id)
        .then(data => {
            this.saveTextAsFile(data, 'locations.json');

            this.isDataAvailable = true;
        })
        .catch(error => {
            this.errorHandler.do(error);
            this.isDataAvailable = true;
        });
    }

    getAll(): void {
        this.questionGroupService.getQuestionGroups()
            .then(questionGroups => {
                this.questionGroups = questionGroups;
                if (this.questionGroup == null) {
                    this.questionGroup = this.questionGroups[1];
                }
                this.questionService.getQuestions(this.questionGroup.id)
                    .then(questions => {
                        this.questions = questions;
                        this.isDataAvailable = true;
                    })
                    .catch(error => {
                        this.errorHandler.do(error);
                        this.isDataAvailable = true;
                    });
            })
            .catch(error => {
                this.errorHandler.do(error);
                this.isDataAvailable = true;
            });
        }

    getAllQuestions(): void {
        this.questionService.getQuestions(this.questionGroup.id)
            .then(questions => {
                this.questions = questions;
                this.isDataAvailable = true;
            })
            .catch(error => {
                this.errorHandler.do(error);
                this.isDataAvailable = true;
            });
    }

    edit(questionId: string, questionGroupId: string): void {
        this.router.navigate(['question/detail', questionId, questionGroupId]);
    }

    add(questionGroupId: string): void {
        this.router.navigate(['question/detail', 0, questionGroupId]);
    }

    delete(questionId: string): void {
        this.isDataAvailable = false;
        this.questionService.deleteQuestion(questionId)
            .then(result => {
                if (result.code === ResultCode.Ok) {
                    this.getAll();
                }
            })
            .catch(error => {
                this.errorHandler.do(error);
                this.isDataAvailable = true;
            });
    }

    onChanged() {
        this.getAllQuestions();
    }

    saveTextAsFile(blob, filename) {

        var e = document.createEvent('MouseEvents');
        var a = document.createElement('a');
        // FOR IE:

        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(blob, filename);
        } else {
            var e = document.createEvent('MouseEvents'),
                a = document.createElement('a');

            a.download = filename;
            a.href = window.URL.createObjectURL(blob);
            a.dataset.downloadurl = ['text/plain', a.download, a.href].join(':');
            e.initEvent('click', true, false);
            a.dispatchEvent(e);
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/components/question-list/question-list.component.ts